// Lightweight parallax for [data-parallax-hero] — no dependencies, respects reduced-motion.
(function () {
  function init() {
    var heroes = Array.prototype.slice.call(document.querySelectorAll('[data-parallax-hero]'));
    if (!heroes.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var ticking = false;

    function update() {
      heroes.forEach(function (hero) {
        var img = hero.querySelector('.hero-media img');
        if (!img) return;
        var rect = hero.getBoundingClientRect();
        var progress = -rect.top / (rect.height || 1);
        var offset = progress * 110;
        img.style.transform = 'translateY(' + offset.toFixed(1) + 'px) scale(1.15)';
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
